/**
 * @class ProductCardSwatches
 * @classdesc This class handles all of the actions of the swatch buttons on the product cards.
 *
 * @extends Core.Component
 */
export default class ProductCardSwatches extends Core.Component {
  constructor(el, context) {
    super(el, context);

    this.swatchButtons = this.el.querySelectorAll('[data-swatch-button]');
    this.showMoreButton = this.el.querySelector('[data-swatches-show-more]');

    this.swatchButtons.forEach(swatchButton => {
      this.events.register(swatchButton, 'click', () => {
        // Fire off event to indicate which swatch was clicked
        let detail = { color: swatchButton.dataset.color }
        if (swatchButton.dataset.variantIndex) {
          detail.variantIndex = parseInt(swatchButton.dataset.variantIndex, 10);
        }

        const clickEvent = new CustomEvent('swatch:update', { detail });
        this.el.dispatchEvent(clickEvent);

        this.swatchButtons.forEach(button => {
          button.dataset.selected = '';
        });

        swatchButton.dataset.selected = 'selected';
      });
    });

    this.hiddenButtonsCheck();
  }

  hiddenButtonsCheck() {
    // We need to hide the swatches that are overflowing the container and handle showing them
    // after clicking the show more button.
    const rowTop = this.swatchButtons[0].getBoundingClientRect().top;

    this.hiddenButtons = [...this.swatchButtons].reduce((hiddenButtons, nextButton) => {
      if (hiddenButtons.length > 0 || nextButton.getBoundingClientRect().top > rowTop) {
        return hiddenButtons.concat(nextButton);
      }

      return hiddenButtons;
    }, []);

    if (this.hiddenButtons.length > 0) {
      // Hide all of the buttons that are overflowing so keyboard can't access them
      this.hiddenButtons.forEach(button => button.classList.add('hidden'));

      this.showMoreButton.innerHTML = this.showMoreButton.innerHTML.replace('count', this.hiddenButtons.length);
      this.el.classList.add('product-card-swatches--collapsed');
      this.showMoreButton.classList.remove('hidden');

      this.events.register(this.showMoreButton, 'click', () => {
        this.el.classList.remove('product-card-swatches--collapsed');
        this.el.classList.add('product-card-swatches--expanded');

        this.hiddenButtons.forEach(button => button.classList.remove('hidden'));
      });
    }

  }
}
